// refactor sass to stylejs (no theme usage)
import UiDialog from 'ui-components/ui-dialog/UiDialog';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledDisplayError = styled('div')(
  () => css`
    .display-errors {
      .title {
        font-style: normal;
        font-weight: 800;
        font-size: 1rem;
        color: #f16063;
        display: block;
        white-space: nowrap;
      }
      .more-details {
        font-size: 0.75rem;
        color: #f16063;
        border-bottom: 1px solid #f16063;
        cursor: pointer;
      }
    }
  `
);

export const StyledDisplayErrorDialog = styled(UiDialog)(
  () => css`
    &.display-errors-modal {
      .title {
        color: #222222;
        font-style: normal;
        font-weight: bold;
        font-size: 0.875rem;
      }
      .block-errors {
        overflow: hidden;
        direction: ltr;
        user-select: text;
        color: #f16063;
      }
    }
  `
);
